import notasFiscaisApi from '@/app/services/notasfiscais.js';
// import faturamentosApi from '@/services/faturamentos';
import clientesApi from '@/app/services/clientes';

const nota = {
  nfse_numero: null,
  nfse_codigo_verificacao: null,
  nfse_data_emissao: null,
  tomador_cpfcnpj: null,
  tomador_razao_social: null,
  status: null,
  nota_substituta: null,
  nota_substituida: null,
  emitente_id: null
}

export default {
  namespaced: true,

  state: {
    notafiscal: {},
    count_notas_autorizadas: 0,
    count_notas_erro: 0,
    count_notas_processamento: 0,
    count_notas_aguardando_emissao: 0,
    notasfiscais: [],
    loading: false,
    fatura: {},
    subfatura: {},
    nota_fiscal_cancelada: {
      nfse_numero: null,
      nfse_codigo_verificacao: null,
      nfse_data_emissao: null,
      tomador_cpfcnpj: null,
      tomador_razao_social: null,
      status: null,
      nota_substituta: null,
      nota_substituida: null,
      emitente_id: null
    },
    nota_substituta: {
      nfse_numero: null,
      nfse_codigo_verificacao: null,
      nfse_data_emissao: null,
      tomador_cpfcnpj: null,
      tomador_razao_social: null,
      status: null,
      nota_substituta: null,
      nota_substituida: null,
      emitente_id: null
    },
    tomador: {}

  },

  getters: {
    // TODO:
  },

  mutations: {
    SET_NOTAFISCAL(state, notafiscal) {
      state.notafiscal = notafiscal;
    },

    SET_NOTASFISCAIS(state, notasfiscais) {
      state.notasfiscais = notasfiscais.notas;
      state.count_notas_autorizadas = notasfiscais.count_notas_autorizadas;
      state.count_notas_erro = notasfiscais.count_notas_erro;
      state.count_notas_processamento = notasfiscais.count_notas_processamento;
      state.count_notas_aguardando_emissao = notasfiscais.count_notas_aguardando_emissao;
    },

    RESET_NOTAFISCAL(state, notafiscal) {
      state.notafiscal = {};
    },

    SET_LOADING(state, payload) {
      state.loading = payload;
    },

    SET_FATURA(state, fatura) {
      state.fatura = fatura;
    },

    EXCLUIR(state, id) {
      const index = state.notasfiscais.data.findIndex(nota => nota.id == id);
      if (index > -1) {
        state.notasfiscais.data.splice(index, 1);
      }
    },

    SET_SUBFATURA(state, subfatura) {
      state.subfatura = subfatura;
    },

    SET_NOTAFISCAL_CANCELADA(state, nota_fiscal_cancelada) {
      state.nota_fiscal_cancelada = nota_fiscal_cancelada;
    },

    SET_TOMADOR(state, tomador) {
      state.tomador = tomador;
    },

    SET_NOTAS_SUBSTITUTAS(state, notas) {
      state.nota_fiscal_cancelada = notas.nota_substituida;
      state.nota_substituta = notas.nota_substituta;
    },

    RESET_NOTAS(state) {
      state.nota_fiscal_cancelada = {...nota};
      state.nota_substituta = {...nota};
    }
  },

  actions: {
    async listarNotasFiscais({commit, state}, filtro) {
      try {
        commit('SET_LOADING', true);
        const notasfiscais = await notasFiscaisApi.list(filtro);
        commit('SET_NOTASFISCAIS', notasfiscais);

      } finally {
        commit('SET_LOADING', false);
      }
    },

    async abrirNotaFiscal({commit}, id) {
      console.log('Ação abrirNotaFiscal com id:', id);
      const notafiscal = await notasFiscaisApi.show(id);
      commit('SET_NOTAFISCAL', notafiscal);
    },

    async excluirNotaFiscal({commit}, id) {
      await notasFiscaisApi.excluir(id);
      commit('EXCLUIR', id);
    },

    async carregarSubFaturamento({commit}, subfatura_id) {
      const faturamento = await faturamentosApi.carregarSubFaturamento(subfatura_id);
      commit('SET_FATURA', faturamento);
    },

    async carregarNfse({commit}, id) {
      const notafiscal = await notasFiscaisApi.carregarNfse(id);
      commit('SET_NOTAFISCAL', notafiscal);
    },

    async getTomador({commit}, cpfcnpj) {
      const tomador = await notasFiscaisApi.getTomador(cpfcnpj);
      commit('SET_TOMADOR', tomador);
    },

    async carregarSubstituta({commit}, nfse_numero) {
      const notas = await notasFiscaisApi.carregarSubstituta(nfse_numero);
      commit('SET_NOTAS_SUBSTITUTAS', notas);
    },
  }
}
